import { createIcon } from '@chakra-ui/icons';

export const FileAlt = createIcon({
  displayName: 'FileAlt',
  viewBox: '0 0 20 24',
  d: 'M2.4 0C1.76348 0 1.15303 0.252856 0.702944 0.702944C0.252856 1.15303 0 1.76348 0 2.4V21.6C0 22.2365 0.252856 22.847 0.702944 23.2971C1.15303 23.7471 1.76348 24 2.4 24H16.8C17.4365 24 18.047 23.7471 18.4971 23.2971C18.9471 22.847 19.2 22.2365 19.2 21.6V7.2L12 0H2.4ZM2.4 2.4H10.8V8.4H16.8V21.6H2.4V2.4ZM4.8 12V14.4H14.4V12H4.8ZM4.8 16.8V19.2H10.8V16.8H4.8Z',
});
